<template>
  <header class="header">
    <!-- header__top -->
    <div class="header__top" :class="{ color: !fullHeader }" v-sticky>
      <b-container
        :fluid="containerFluid"
        class="d-flex justify-content-between"
      >
        <Nav></Nav>
        <!-- <NavHome v></NavHome> -->
      </b-container>
    </div>
    <!-- header__top -->

    <!-- header__middle -->
    <div class="header__middle header__middle--secondary" v-if="fullHeader">
      <div class="container">
        <h1 class="page-title header__page-title">{{ title }}</h1>
      </div>
    </div>
    <!-- header__middle -->
  </header>
</template>

<script>
import Nav from '@/components/Nav';
// import NavHome from '@/components/NavHome';
import Sticky from '@/directives/sticky';

export default {
  props: {
    fullHeader: Boolean,
    containerFluid: Boolean,
    title: String
  },
  components: {
    Nav,
    // NavHome
  },
  directives: {
    Sticky
  },
  computed: {
    isContainerFluid() {
      return this.fullHeader ? 'container-fluid' : 'container';
    }
  }
};
</script>
